// extracted by mini-css-extract-plugin
export default {"socialIcon":"SocialIcon_socialIcon__xsFe4","large":"SocialIcon_large__JlMS5"};